import React, { useState } from 'react';
import { Save, Building2, Shield, Users, Link as LinkIcon, CreditCard, Download, CheckCircle, AlertCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
export function SettingsPage() {
  const [activeTab, setActiveTab] = useState('general');
  const integrations = [{
    name: 'Slack',
    status: 'connected',
    desc: 'Receive booking notifications',
    icon: 'https://cdn.iconscout.com/icon/free/png-256/free-slack-logo-icon-download-in-svg-png-gif-file-formats--social-media-pack-logos-icons-498424.png'
  }, {
    name: 'Google Calendar',
    status: 'connected',
    desc: 'Sync trip dates automatically',
    icon: 'https://cdn.iconscout.com/icon/free/png-256/free-google-calendar-logo-icon-download-in-svg-png-gif-file-formats--google-apps-pack-logos-icons-1572242.png'
  }, {
    name: 'SAP Concur',
    status: 'disconnected',
    desc: 'Expense management sync',
    icon: 'https://cdn.worldvectorlogo.com/logos/concur.svg'
  }, {
    name: 'Salesforce',
    status: 'disconnected',
    desc: 'Link trips to client accounts',
    icon: 'https://cdn.iconscout.com/icon/free/png-256/free-salesforce-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-vol-6-pack-logos-icons-3030008.png'
  }, {
    name: 'QuickBooks',
    status: 'disconnected',
    desc: 'Financial reporting sync',
    icon: 'https://cdn.iconscout.com/icon/free/png-256/free-quickbooks-logo-icon-download-in-svg-png-gif-file-formats--technology-social-media-vol-5-pack-logos-icons-3030238.png'
  }, {
    name: 'Okta SSO',
    status: 'connected',
    desc: 'Single sign-on authentication',
    icon: 'https://cdn.worldvectorlogo.com/logos/okta-1.svg'
  }];
  return <div className="space-y-6" data-id="element-1302">
      <div className="flex items-center justify-between" data-id="element-1303">
        <div data-id="element-1304">
          <h2 className="text-2xl font-bold text-slate-800" data-id="element-1305">Settings</h2>
          <p className="text-slate-500" data-id="element-1306">
            Manage your organization preferences and policies.
          </p>
        </div>
        <button className="flex items-center rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700" data-id="element-1307">
          <Save className="mr-2 h-4 w-4" data-id="element-1308" />
          Save Changes
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-4" data-id="element-1309">
        {/* Settings Nav */}
        <div className="lg:col-span-1" data-id="element-1310">
          <nav className="space-y-1 rounded-xl border border-slate-200 bg-white p-2" data-id="element-1311">
            {[{
            id: 'general',
            label: 'General',
            icon: Building2
          }, {
            id: 'policy',
            label: 'Travel Policy',
            icon: Shield
          }, {
            id: 'workflow',
            label: 'Approval Workflow',
            icon: CheckCircle
          }, {
            id: 'users',
            label: 'Users & Roles',
            icon: Users
          }, {
            id: 'integrations',
            label: 'Integrations',
            icon: LinkIcon
          }, {
            id: 'billing',
            label: 'Billing',
            icon: CreditCard
          }].map(item => <button key={item.id} onClick={() => setActiveTab(item.id)} className={`w-full flex items-center rounded-lg px-3 py-2 text-left text-sm font-medium transition-colors ${activeTab === item.id ? 'bg-blue-50 text-blue-700' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-1312">
                <item.icon className="mr-3 h-4 w-4" data-id="element-1313" />
                {item.label}
              </button>)}
          </nav>
        </div>

        {/* Settings Content */}
        <div className="lg:col-span-3 space-y-6" data-id="element-1314">
          {activeTab === 'general' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm space-y-6 animate-in fade-in" data-id="element-1315">
              <h3 className="text-lg font-semibold text-slate-900 border-b border-slate-100 pb-4" data-id="element-1316">
                Organization Details
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1317">
                <div data-id="element-1318">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1319">
                    Organization Name
                  </label>
                  <input type="text" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="Acme Corp" data-id="element-1320" />
                </div>
                <div data-id="element-1321">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1322">
                    Industry
                  </label>
                  <select className="block w-full rounded-lg border border-slate-300 p-2.5" data-id="element-1323">
                    <option data-id="element-1324">Technology</option>
                    <option data-id="element-1325">Finance</option>
                    <option data-id="element-1326">Healthcare</option>
                  </select>
                </div>
                <div data-id="element-1327">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1328">
                    Primary Email
                  </label>
                  <input type="email" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="admin@acme.com" data-id="element-1329" />
                </div>
                <div data-id="element-1330">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1331">
                    Phone Number
                  </label>
                  <input type="tel" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="+1 (555) 123-4567" data-id="element-1332" />
                </div>
                <div className="md:col-span-2" data-id="element-1333">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-1334">
                    Address
                  </label>
                  <input type="text" className="block w-full rounded-lg border border-slate-300 p-2.5" defaultValue="123 Innovation Dr, San Francisco, CA 94105" data-id="element-1335" />
                </div>
              </div>
            </div>}

          {activeTab === 'policy' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm animate-in fade-in" data-id="element-1336">
              <h3 className="text-lg font-semibold text-slate-900 mb-4" data-id="element-1337">
                Travel Policy Configuration
              </h3>
              <div className="space-y-6" data-id="element-1338">
                <div data-id="element-1339">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1340">
                    Flight Booking Cap (Domestic)
                  </label>
                  <div className="flex items-center gap-2" data-id="element-1341">
                    <span className="text-slate-500" data-id="element-1342">$</span>
                    <input type="number" className="block w-32 rounded-lg border border-slate-300 p-2 text-slate-900" defaultValue="500" data-id="element-1343" />
                    <span className="text-sm text-slate-500" data-id="element-1344">per ticket</span>
                  </div>
                </div>
                <div data-id="element-1345">
                  <label className="block text-sm font-medium text-slate-700 mb-2" data-id="element-1346">
                    Flight Booking Cap (International)
                  </label>
                  <div className="flex items-center gap-2" data-id="element-1347">
                    <span className="text-slate-500" data-id="element-1348">$</span>
                    <input type="number" className="block w-32 rounded-lg border border-slate-300 p-2 text-slate-900" defaultValue="1500" data-id="element-1349" />
                    <span className="text-sm text-slate-500" data-id="element-1350">per ticket</span>
                  </div>
                </div>
                <div className="border-t border-slate-200 pt-4" data-id="element-1351">
                  <div className="flex items-center justify-between" data-id="element-1352">
                    <div data-id="element-1353">
                      <h4 className="text-sm font-medium text-slate-900" data-id="element-1354">
                        Require Approval for All Trips
                      </h4>
                      <p className="text-xs text-slate-500" data-id="element-1355">
                        If disabled, only trips exceeding budget will require
                        approval.
                      </p>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-1356">
                      <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1357" />
                      <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-1358"></div>
                    </label>
                  </div>
                </div>
              </div>
            </div>}

          {activeTab === 'workflow' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm animate-in fade-in space-y-6" data-id="element-1359">
              <h3 className="text-lg font-semibold text-slate-900 border-b border-slate-100 pb-4" data-id="element-1360">
                Approval Workflow Builder
              </h3>

              <div className="space-y-4" data-id="element-1361">
                {[{
              level: 1,
              role: 'Direct Manager',
              desc: 'Always required for every booking',
              threshold: null
            }, {
              level: 2,
              role: 'Department Head',
              desc: 'Required for trips exceeding threshold',
              threshold: 1000
            }, {
              level: 3,
              role: 'Finance Review',
              desc: 'Required for trips exceeding threshold',
              threshold: 2500
            }, {
              level: 4,
              role: 'VP Approval',
              desc: 'Required for trips exceeding threshold',
              threshold: 5000
            }].map(step => <div key={step.level} className="flex items-center justify-between p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-1362">
                    <div className="flex items-center gap-4" data-id="element-1363">
                      <div className="h-8 w-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-sm" data-id="element-1364">
                        {step.level}
                      </div>
                      <div data-id="element-1365">
                        <h4 className="font-medium text-slate-900" data-id="element-1366">
                          {step.role}
                        </h4>
                        <p className="text-xs text-slate-500" data-id="element-1367">{step.desc}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-4" data-id="element-1368">
                      {step.threshold !== null && <div className="flex items-center gap-2" data-id="element-1369">
                          <span className="text-xs text-slate-500" data-id="element-1370">Over</span>
                          <div className="relative" data-id="element-1371">
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 text-xs" data-id="element-1372">
                              $
                            </span>
                            <input type="number" className="w-20 rounded border border-slate-300 py-1 pl-4 text-sm" defaultValue={step.threshold} data-id="element-1373" />
                          </div>
                        </div>}
                      <label className="relative inline-flex items-center cursor-pointer" data-id="element-1374">
                        <input type="checkbox" className="sr-only peer" defaultChecked data-id="element-1375" />
                        <div className="w-9 h-5 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600" data-id="element-1376"></div>
                      </label>
                    </div>
                  </div>)}
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-slate-100" data-id="element-1377">
                <div data-id="element-1378">
                  <h4 className="font-medium text-slate-900" data-id="element-1379">
                    Auto-approve small trips
                  </h4>
                  <p className="text-xs text-slate-500" data-id="element-1380">
                    Skip approval for trips under $500
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer" data-id="element-1381">
                  <input type="checkbox" className="sr-only peer" data-id="element-1382" />
                  <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" data-id="element-1383"></div>
                </label>
              </div>
            </div>}

          {activeTab === 'users' && <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm animate-in fade-in text-center py-12" data-id="element-1384">
              <div className="mx-auto h-16 w-16 bg-blue-50 rounded-full flex items-center justify-center mb-4" data-id="element-1385">
                <Users className="h-8 w-8 text-blue-600" data-id="element-1386" />
              </div>
              <h3 className="text-lg font-bold text-slate-900" data-id="element-1387">
                User Management
              </h3>
              <p className="text-slate-500 mb-6" data-id="element-1388">
                8 active users, 2 pending invites
              </p>
              <Link to="/admin/users" className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-700" data-id="element-1389">
                Manage Users & Roles
              </Link>
            </div>}

          {activeTab === 'integrations' && <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in" data-id="element-1390">
              {integrations.map(app => <div key={app.name} className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between h-full" data-id="element-1391">
                  <div className="flex items-start justify-between mb-4" data-id="element-1392">
                    <div className="flex items-center gap-3" data-id="element-1393">
                      <div className="h-10 w-10 rounded-lg border border-slate-100 p-1 flex items-center justify-center bg-white" data-id="element-1394">
                        <img src={app.icon} alt={app.name} className="h-6 w-6 object-contain" data-id="element-1395" />
                      </div>
                      <div data-id="element-1396">
                        <h4 className="font-bold text-slate-900" data-id="element-1397">{app.name}</h4>
                        <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${app.status === 'connected' ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-600'}`} data-id="element-1398">
                          {app.status === 'connected' ? 'Connected' : 'Not Connected'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-slate-500 mb-4" data-id="element-1399">{app.desc}</p>
                  <button className={`w-full py-2 rounded-lg text-sm font-medium border transition-colors ${app.status === 'connected' ? 'border-red-200 text-red-600 hover:bg-red-50' : 'border-blue-200 text-blue-600 hover:bg-blue-50'}`} data-id="element-1400">
                    {app.status === 'connected' ? 'Disconnect' : 'Connect'}
                  </button>
                </div>)}
            </div>}

          {activeTab === 'billing' && <div className="space-y-6 animate-in fade-in" data-id="element-1401">
              <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-xl p-6 text-white shadow-lg" data-id="element-1402">
                <div className="flex justify-between items-start mb-6" data-id="element-1403">
                  <div data-id="element-1404">
                    <h3 className="text-lg font-bold" data-id="element-1405">Enterprise Plan</h3>
                    <p className="text-slate-400 text-sm" data-id="element-1406">
                      $12/user/month • 142 active users
                    </p>
                  </div>
                  <span className="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-1407">
                    Active
                  </span>
                </div>
                <div className="flex justify-between items-end" data-id="element-1408">
                  <div data-id="element-1409">
                    <p className="text-xs text-slate-400 uppercase tracking-wider mb-1" data-id="element-1410">
                      Next Billing Date
                    </p>
                    <p className="font-mono" data-id="element-1411">Dec 1, 2023</p>
                  </div>
                  <div className="text-right" data-id="element-1412">
                    <p className="text-2xl font-bold" data-id="element-1413">$1,704.00</p>
                    <p className="text-xs text-slate-400" data-id="element-1414">Estimated total</p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm" data-id="element-1415">
                <h3 className="font-bold text-slate-900 mb-4" data-id="element-1416">
                  Payment Method
                </h3>
                <div className="flex items-center justify-between p-4 border border-slate-200 rounded-lg" data-id="element-1417">
                  <div className="flex items-center gap-4" data-id="element-1418">
                    <div className="h-10 w-16 bg-slate-100 rounded flex items-center justify-center" data-id="element-1419">
                      <span className="font-bold text-slate-600 italic" data-id="element-1420">
                        VISA
                      </span>
                    </div>
                    <div data-id="element-1421">
                      <p className="font-medium text-slate-900" data-id="element-1422">
                        Visa ending in 4242
                      </p>
                      <p className="text-sm text-slate-500" data-id="element-1423">Expires 12/25</p>
                    </div>
                  </div>
                  <button className="text-sm font-medium text-blue-600 hover:text-blue-700" data-id="element-1424">
                    Update
                  </button>
                </div>
              </div>

              <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-1425">
                <div className="px-6 py-4 border-b border-slate-200" data-id="element-1426">
                  <h3 className="font-bold text-slate-900" data-id="element-1427">Invoice History</h3>
                </div>
                <table className="min-w-full divide-y divide-slate-200" data-id="element-1428">
                  <thead className="bg-slate-50" data-id="element-1429">
                    <tr data-id="element-1430">
                      <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1431">
                        Date
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1432">
                        Amount
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-slate-500 uppercase" data-id="element-1433">
                        Status
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-slate-500 uppercase" data-id="element-1434">
                        Invoice
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-200" data-id="element-1435">
                    {[{
                  date: 'Nov 1, 2023',
                  amount: '$1,680.00',
                  status: 'Paid'
                }, {
                  date: 'Oct 1, 2023',
                  amount: '$1,656.00',
                  status: 'Paid'
                }, {
                  date: 'Sep 1, 2023',
                  amount: '$1,620.00',
                  status: 'Paid'
                }].map((inv, i) => <tr key={i} data-id="element-1436">
                        <td className="px-6 py-4 text-sm text-slate-900" data-id="element-1437">
                          {inv.date}
                        </td>
                        <td className="px-6 py-4 text-sm text-slate-900" data-id="element-1438">
                          {inv.amount}
                        </td>
                        <td className="px-6 py-4" data-id="element-1439">
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-emerald-100 text-emerald-800" data-id="element-1440">
                            {inv.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-right" data-id="element-1441">
                          <button className="text-blue-600 hover:text-blue-800" data-id="element-1442">
                            <Download className="h-4 w-4 inline" data-id="element-1443" />
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}